import { DashboardAddContentFiltersModels, UpdateDashboardContentFiltersModels, DashboardContentFilterDetailsModels } from './../models/dashboard-add-content-filters.models';
import { UpdateDashboardLayoutDetailsModels } from './../models/dashboard-update-layout-details.models';
import { DashboardAddLayoutModels } from './../models/dashboard-add-layoutdetails.models';
import { DashboardWidgetListModels } from './../models/dashboard-widget-list.models';
import { DashboardAddContentModels } from './../models/dashboard-add-content.models';
import { DashboardAddChannelModels } from './../models/dashboard-add-channel.models';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class DashboardService {
    dashboardApi: string = "";
    constructor(private http: HttpClient)
    {
        this.dashboardApi = environment.configUrl + "DashBoard";
    }

    getDashboardDetails(): Observable<any>{
        return this.http.get<any>(this.dashboardApi);
    }

    getDashboardWidgetList(): Observable<DashboardWidgetListModels[]>{
        const api: string =  environment.configUrl + "DashBoardWidget";
        return this.http.get<any>(api);
    }

    addNewDashboardChannel(dashboardChannelData: DashboardAddChannelModels){
        return this.http.post<any>(this.dashboardApi, dashboardChannelData);
    }

    addNewDashboardLayout(dashboardLayoutData: DashboardAddLayoutModels){
        const api: string = `${environment.configUrl}DashBoardLayOutDetail`;
        return this.http.post<any>(api, dashboardLayoutData);
    }

    addDashboardContent(dashboardContentData: DashboardAddContentModels){
        const api: string =  environment.configUrl + "DashBoardContent";
        return this.http.post<any>(api, dashboardContentData);
    }

    addDashboardContentFilters(contentFilters: DashboardAddContentFiltersModels[]): Observable<DashboardContentFilterDetailsModels[]>{
        const api: string = `${environment.configUrl}DashBoardFilter`;
        return this.http.post<any>(api, contentFilters);
    }

    updateDashboardContentFilters(contentFilters: UpdateDashboardContentFiltersModels[]): Observable<DashboardContentFilterDetailsModels[]>{
        const api: string = `${environment.configUrl}DashBoardFilter`;
        return this.http.put<any>(api, contentFilters);
    }

    updateDashboardLayoutDetails(dashboardLayoutDetailsData: UpdateDashboardLayoutDetailsModels){
        const api: string = `${environment.configUrl}DashBoardLayOutDetail`;
        return this.http.put<any>(api, dashboardLayoutDetailsData);
    }

    updateDashboardChannelAsDefault(channelId: number){
        const api: string = `${environment.configUrl}DashBoard/${channelId}`;
        return this.http.put<any>(api, null);
    }

    deleteDashboardChannel(channelId: number){
        const api: string = `${environment.configUrl}DashBoard/${channelId}`;
        return this.http.delete<any>(api);
    }

    deleteDashboardContent(contentDetailsId: number){
        const api: string = `${environment.configUrl}DashBoardContent/${contentDetailsId}`;
        return this.http.delete<any>(api);
    }

    deleteDashboardLayout(layoutId: number){
        const api: string = `${environment.configUrl}DashBoardLayOutDetail/${layoutId}`;
        return this.http.delete<any>(api);
    }

    deleteDashboardContenetFilter(filterId: number){
        const api: string = `${environment.configUrl}DashBoardFilter/${filterId}`;
        return this.http.delete<any>(api);
    }

    //Finance
    getFinanceAccountPayable(fromDate: string, toDate: string, dateFilterType: string): Observable<any>{

        let params = new HttpParams();
        params = params.append('reportType', 'AccountsPayableDashboard');
        params = params.append('fromDate', fromDate);
        params = params.append('toDate', toDate);
        params = params.append('dateFilterType', dateFilterType);

        const api: string =  environment.financeURl + "FinancialReport/AccountsPayableDashboard";
        return this.http.get<any>(api, {params});
    }

    getFinanceAccountReceivable(fromDate: string, toDate: string, dateFilterType: string): Observable<any>{

        let params = new HttpParams();
        params = params.append('reportType', 'AccountsReceivableDashboard');
        params = params.append('fromDate', fromDate);
        params = params.append('toDate', toDate);
        params = params.append('dateFilterType', dateFilterType);

        const api: string =  environment.financeURl + "FinancialReport/AccountsReceivableDashboard";
        return this.http.get<any>(api, {params});
    }
}
